<template>
  <!-- 生活方式 -->
  <div>
    <!-- 体育锻炼 -->
      <div class="section-title">
         <i class="el-icon-menu" style="margin-right: 10px;"></i>体育锻炼
         <el-divider></el-divider>
      </div>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item  label="锻炼频率" prop="hardeningFrequency">
            <el-radio-group v-model="formData.hardeningFrequency" size="mini">
             <el-radio-button
                v-for="option in exerciseFrequencyDict"
                :key="option.value"
                :label="option.value">
              {{ option.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="每次锻炼时间">
            <el-input  v-model="formData.everyHardeningTime" placeholder="请输入每次锻炼时间">
              <template slot="append">分钟</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="坚持锻炼时间">
            <el-input  v-model="formData.insistHardeningTime" placeholder="请输入坚持锻炼时间">
              <template slot="append">年</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="锻炼方式">
            <div class="flex-center">
                <el-select v-model="formData.hardeningMode" placeholder="请选择" size="mini" style="width: 100%;">
                  <el-option
                      v-for="option in hardeningModeDict"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value">
                    </el-option>
                </el-select>
                <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'HARDENING_MODE_DICT')"></el-button>
            </div>

          </el-form-item>
        </el-col>
      </el-row>

      <!-- 饮食习惯 -->
      <div class="section-title">
         <i class="el-icon-menu" style="margin-right: 10px;"></i>饮食习惯
         <el-divider></el-divider>
     </div>
     <el-row :gutter="24">
       <el-col :span="24">
         <el-form-item  label="饮食习惯">
           <el-radio-group v-model="formData.eatClitocybineEqualization" size="mini">
             <el-radio :label="'1'">荤素均衡</el-radio>
             <el-radio :label="'2'">荤食为主</el-radio>
             <el-radio :label="'3'">素食为主</el-radio>
           </el-radio-group>
           <el-checkbox v-model="formData.eatHobbySalt" :true-label="'1'" :false-label="'0'">嗜盐</el-checkbox>
           <el-checkbox v-model="formData.eatHobbyOil" :true-label="'1'" :false-label="'0'">嗜油</el-checkbox>
           <el-checkbox v-model="formData.eatHobbySugar" :true-label="'1'" :false-label="'0'">嗜糖</el-checkbox>
         </el-form-item>
       </el-col>
     </el-row>

      <!-- 吸烟情况 -->
      <div class="section-title">
        <i class="el-icon-menu" style="margin-right: 10px;"></i>吸烟情况
        <el-divider></el-divider>
      </div>
      <el-row :gutter="24">
        <el-col :span="6">
         <el-form-item  label="吸烟状况">
           <el-radio-group v-model="formData.smokingCircumstance" size="mini">
            <el-radio-button
               v-for="option in smokingStatusDict"
               :key="option.value"
               :label="option.value">
             {{ option.label }}
             </el-radio-button>
           </el-radio-group>
         </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="日吸烟量" prop="dailySmokingQuantity">
            <el-input  v-model="formData.dailySmokingQuantity" placeholder="请输入日吸烟量">
              <template slot="append">支/天</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="开始吸烟年龄">
            <el-input  v-model="formData.beginSmokingAge" placeholder="请输入开始吸烟年龄">
               <template slot="append">岁</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="戒烟年龄">
            <el-input  v-model="formData.quitSmokingAge" placeholder="请输入戒烟年龄">
              <template slot="append">岁</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 饮酒情况 -->
      <div class="section-title">
        <i class="el-icon-menu" style="margin-right: 10px;"></i>饮酒情况
        <el-divider></el-divider>
      </div>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item  label="饮酒频率" >
            <el-radio-group v-model="formData.drinkFrequency" size="mini">
             <el-radio-button
                v-for="option in drinkingFrequencyDict"
                :key="option.value"
                :label="option.value">
              {{ option.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="日饮酒量" prop="everyAlcoholTolerance">
            <el-input  v-model="formData.everyAlcoholTolerance" placeholder="请输入日饮酒量">
               <template slot="append">两/天</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="开始饮酒年龄" prop="beginDrinkAge">
            <el-input  v-model="formData.beginDrinkAge" placeholder="请输入开始饮酒年龄">
              <template slot="append">岁</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="是否戒酒" prop="isDryOut">
            <el-radio-group v-model="formData.isDryOut" size="mini">
             <el-radio-button label="1">未戒酒</el-radio-button>
             <el-radio-button label="2">已戒酒</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="戒酒年龄" prop="dryOutAge">
            <el-input  v-model="formData.dryOutAge" placeholder="请输入戒酒年龄">
              <template slot="append">岁</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item  label="近一年是否醉酒" label-width="130px">
             <el-radio-group v-model="formData.oneYearIsTemulentia" size="mini">
                <el-radio-button label="1">是</el-radio-button>
                <el-radio-button label="2">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item  label="饮酒种类" prop="drinkTypes">
            <el-checkbox v-model="formData.drinkWhiteSpirits" :true-label="'1'" :false-label="'0'">白酒</el-checkbox>
            <el-checkbox v-model="formData.drinkBeer" :true-label="'1'" :false-label="'0'">啤酒</el-checkbox>
            <el-checkbox v-model="formData.drinkRedWine" :true-label="'1'" :false-label="'0'">红酒</el-checkbox>
            <el-checkbox v-model="formData.drinkYellowWine" :true-label="'1'" :false-label="'0'">黄酒</el-checkbox>
            <el-checkbox v-model="formData.drinkOther" :true-label="'1'" :false-label="'0'">其他</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item  label="其他饮酒种类" prop="drinkOthers">
            <el-input  v-model="formData.drinkOthers" placeholder="请输入其他饮酒种类"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

     <!-- 职业病危害因素接触史 -->
     <div class="section-title">
       <i class="el-icon-menu" style="margin-right: 10px;"></i>职业病危害因素接触史
       <el-divider></el-divider>
     </div>
     <el-row :gutter="24">
       <el-col :span="24">
         <el-form-item label="职业病危害因素" label-width="130px">
           <el-checkbox v-model="formData.occHazHistory0" true-label="'1'" false-label="'0'">无</el-checkbox>
         </el-form-item>
       </el-col>
     </el-row>

     <!-- 毒物种类 -->
    <fieldset class="custom-fieldset">
       <legend class="custom-legend">毒物种类</legend>
       <el-row :gutter="24">
         <el-col :span="5">
           <el-form-item label="粉尘">
             <el-checkbox v-model="formData.occHazHistory1" true-label="'1'" false-label="'0'" :disabled="formData.occHazHistory0 === '1'">有</el-checkbox>
             <el-checkbox v-model="formData.occHazHistory1" true-label="0" false-label="1" :disabled="formData.occHazHistory0 === '1'">无</el-checkbox>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="工种">
             <el-input v-model="formData.poisonDust" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="危害名称">
             <el-input v-model="formData.hazardNameDust" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="从业时间">
             <el-date-picker v-model="formData.workTimeDust" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-date-picker>
           </el-form-item>
         </el-col>
         <el-col :span="4">
           <el-form-item label="防护措施">
             <el-radio-group v-model="formData.poisonDustIspre" size="mini" :disabled="formData.occHazHistory0 === '1'">
               <el-radio-button label="1">有</el-radio-button>
               <el-radio-button label="0">无</el-radio-button>
             </el-radio-group>
           </el-form-item>
         </el-col>
       </el-row>

       <!-- 放射物质 -->
       <el-row :gutter="24" style="margin-top: 15px;">
         <el-col :span="5">
           <el-form-item label="放射物质">
             <el-checkbox v-model="formData.occHazHistory2" true-label="'1'" false-label="'0'" :disabled="formData.occHazHistory0 === '1'">有</el-checkbox>
             <el-checkbox v-model="formData.occHazHistory2" true-label="0" false-label="1" :disabled="formData.occHazHistory0 === '1'">无</el-checkbox>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="工种">
             <el-input v-model="formData.poisonRadiogen" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="危害名称">
             <el-input v-model="formData.hazardNameRad" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="从业时间">
             <el-date-picker v-model="formData.workTimeRad" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-date-picker>
           </el-form-item>
         </el-col>
         <el-col :span="4">
           <el-form-item label="防护措施">
             <el-radio-group v-model="formData.poisonRadiogenIspre" size="mini" :disabled="formData.occHazHistory0 === '1'">
               <el-radio-button label="1">有</el-radio-button>
               <el-radio-button label="0">无</el-radio-button>
             </el-radio-group>
           </el-form-item>
         </el-col>
       </el-row>

       <!-- 物理因素 -->
       <el-row :gutter="24" style="margin-top: 15px;">
         <el-col :span="5">
           <el-form-item label="物理因素">
             <el-checkbox v-model="formData.occHazHistory3" true-label="'1'" false-label="'0'" :disabled="formData.occHazHistory0 === '1'">有</el-checkbox>
             <el-checkbox v-model="formData.occHazHistory3" true-label="0" false-label="1" :disabled="formData.occHazHistory0 === '1'">无</el-checkbox>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="工种">
             <el-input v-model="formData.poisonPhysicalfactor" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="危害名称">
             <el-input v-model="formData.hazardNamePhy" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="从业时间">
             <el-date-picker v-model="formData.workTimePhy" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-date-picker>
           </el-form-item>
         </el-col>
         <el-col :span="4">
           <el-form-item label="防护措施">
             <el-radio-group v-model="formData.poisonPhysicalIspre" size="mini" :disabled="formData.occHazHistory0 === '1'">
               <el-radio-button label="1">有</el-radio-button>
               <el-radio-button label="0">无</el-radio-button>
             </el-radio-group>
           </el-form-item>
         </el-col>
       </el-row>

       <!-- 化学物质 -->
       <el-row :gutter="24" style="margin-top: 15px;">
         <el-col :span="5">
           <el-form-item label="化学物质">
             <el-checkbox v-model="formData.occHazHistory4" true-label="'1'" false-label="'0'" :disabled="formData.occHazHistory0 === '1'">有</el-checkbox>
             <el-checkbox v-model="formData.occHazHistory4" true-label="0" false-label="1" :disabled="formData.occHazHistory0 === '1'">无</el-checkbox>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="工种">
             <el-input v-model="formData.poisonChemical" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="危害名称">
             <el-input v-model="formData.hazardNameChe" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="从业时间">
             <el-date-picker v-model="formData.workTimeChe" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-date-picker>
           </el-form-item>
         </el-col>
         <el-col :span="4">
           <el-form-item label="防护措施">
             <el-radio-group v-model="formData.poisonChemicalIspre" size="mini" :disabled="formData.occHazHistory0 === '1'">
               <el-radio-button label="1">有</el-radio-button>
               <el-radio-button label="0">无</el-radio-button>
             </el-radio-group>
           </el-form-item>
         </el-col>
       </el-row>

       <!-- 其它 -->
       <el-row :gutter="24" style="margin-top: 15px;">
         <el-col :span="5">
           <el-form-item label="其它">
             <el-checkbox v-model="formData.occHazHistory5" true-label="'1'" false-label="'0'" :disabled="formData.occHazHistory0 === '1'">有</el-checkbox>
             <el-checkbox v-model="formData.occHazHistory5" true-label="0" false-label="1" :disabled="formData.occHazHistory0 === '1'">无</el-checkbox>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="工种">
             <el-input v-model="formData.poisonOthers"   size="mini" style="width: 100%;" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="危害名称">
             <el-input v-model="formData.hazardNameOth" placeholder="请输入" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-input>
           </el-form-item>
         </el-col>
         <el-col :span="5">
           <el-form-item label="从业时间">
             <el-date-picker v-model="formData.workTimeOth" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;" size="mini" :disabled="formData.occHazHistory0 === '1'"></el-date-picker>
           </el-form-item>
         </el-col>
         <el-col :span="4">
           <el-form-item label="防护措施">
             <el-radio-group v-model="formData.poisonOthersIspre" size="mini" :disabled="formData.occHazHistory0 === '1'">
               <el-radio-button label="1">有</el-radio-button>
               <el-radio-button label="0">无</el-radio-button>
             </el-radio-group>
           </el-form-item>
         </el-col>
       </el-row>
    </fieldset>
  </div>

</template>

<script>
export default {
  name: 'MedicalLifeStyle',
  props: {
    formData: {
      type: Object,
      required: true
    },
    exerciseFrequencyDict: {
      type: Array,
      default: () => []
    },
    hardeningModeDict: {
      type: Array,
      default: () => []
    },
    smokingStatusDict: {
      type: Array,
      default: () => []
    },
    drinkingFrequencyDict: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>
  .main-box{
    overflow-x: hidden;
    overflow-y: auto;
  }
  .custom-fieldset {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 10px;
  }

  /* legend 样式：设置颜色、加粗和位置 */
  .custom-legend {
    /* color: #F56C6C; */
    font-weight: bold;
    font-size: 12px;
    padding: 0 10px;
  }

  /* 模块标题样式 */
  .section-title {
    margin-left: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 15px;
    color: #000;
  }
  .flex-center{
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/ph/archive/medical/medical-lifeStyle.vue